import { UserService } from './../../../services/user.service';
import { Component } from '@angular/core';

@Component({
    selector: 'page-takephoto',
    templateUrl: './takePhoto.component.html',
    styleUrls: ['./takePhoto.component.css'],
    providers:[UserService]
})

export class TakePhotoComponent  {


    constructor(public _userService: UserService){

    }

}